module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("20etO"))).then(() => parcelRequire('1iHdE'));